import React, { useEffect, useState } from "react";
import Select from 'react-select';
import { useReactFlow } from 'reactflow';
import { filter } from 'lodash';

import selectStyles from '../../../../util/selectStyles';
import { CHATBOT_OPTIONS_TYPE } from "../../../../constants/AppConstants";
import { iconMapping } from "../utils";
import IconMC from '../../../../presentation/components/IconMC';

const buildLabel = (opt) => {
  const option = iconMapping[opt.option_type];

  if (option) {
    return (
      <div className="d-flex flex-row">
        <IconMC name={option.iconName} size="base" className="tw-mr-2" />
        <span className="fz-12 font-700">{opt.text}</span>
      </div>
    )
  }
};

const JumpToStep = ({
  chatbotOption,
  setChatbotOption,
  errors
}) => {
  const { getNode, getNodes } = useReactFlow();
  const [stepOptions, setStepOptions] = useState([]);

  const isGrandParentMenu = (node) => {
    if (!chatbotOption.source) return false;

    const parentNode = getNode(chatbotOption.source);

    if (parentNode.data?.option?.fake_option) {
      const grandParentNode = getNode(parentNode.data.option.source);
      return grandParentNode.data.option.option_type == CHATBOT_OPTIONS_TYPE.MENU && grandParentNode.id == node.id;
    };

    return false;
  };

  useEffect(() => {
    const nodes = getNodes();

    let newOptions = filter(nodes, (node) => {
      return node.data?.option?.id &&
        [
          CHATBOT_OPTIONS_TYPE.QUESTION,
          CHATBOT_OPTIONS_TYPE.MENU,
          CHATBOT_OPTIONS_TYPE.API
        ].includes(node.data.option.option_type) &&
        node.id != chatbotOption.source &&
        !node.data.option.fake_option &&
        !isGrandParentMenu(node)
    });

    newOptions = newOptions.map((node) => (
      { value: node.data.option.id, label: buildLabel(node.data.option) }
    ));

    setStepOptions(newOptions);
  }, []);

  const handleSelect = (opt) => {
    setChatbotOption({
      ...chatbotOption,
      jump_to_option: opt.value
    });

  };

  return (
    <>
      <div className="col-md-12 mt-20">
        <div className="figma-field mb-0">
          <label>Seleccione un paso disponible para ir</label>
          <span className="ml-10 error-msg fz-12">{errors.jump_to_error}</span>
          <Select
            options={stepOptions}
            placeholder="Selecciona"
            className={chatbotOption.jump_to_option ? '' : 'select-tag'}
            classNamePrefix={chatbotOption.jump_to_option ? '' : 'select-tag'}
            styles={selectStyles}
            onChange={handleSelect}
            value={[stepOptions.find((el) => el.value == chatbotOption.jump_to_option)]}
            name="jump_to_option"
            components={{
              IndicatorSeparator: () => null
            }}
          />
        </div>
      </div>
    </>
  )
}

export default JumpToStep;
